<template>
  <router-view v-slot="{ Component }">
    <component :is="Component" v-model="user" @[reloadEvent(Component)]="refetch" />
  </router-view>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useFetchQuery } from '@/hooks/fetch';
import { syncHeader } from '@/components/structure/navigation/injects';
import type { Driver, User } from '@/entities/Entities';
import { syncPageBusy } from '@/components/utils/busy/injects';

const route = useRoute();
const { data: user, loading, refetch } = useFetchQuery<User>(`/users/${route.params.userId}`);

const reloadEvent = (component: any) => {
  return component.type.emits?.includes('reload') ? 'reload' : '';
};

syncPageBusy(loading);

const title = computed(() => `${user.value?.firstName ?? ''} ${user.value?.lastName ?? ''}`);

syncHeader(user, (newUser) => ({
  extraBreadcrumbs: [
    computed(() => ({
      label: title.value,
      link: `/users/${user.value?.id}`,
    })),
  ],
  title: computed(() => ({
    text: title.value,
    link: { name: 'users' },
  })),
}));
</script>

<style lang="scss" scoped>
</style>
